module.exports = __webpack_public_path__ + "img/2024-08-29d_2.56b105fc.jpg";